/* eslint-disable no-param-reassign */
import { getStateAndCity, getStateFuelPrices } from '@helpers/fuelPageHelpers'
import { getCurrentDate } from '@utils/date'
import { capitaliseEveryWord, uppercaseFirstLetter } from '@utils/stringUtils'

export function customReplaceAll(string, search, replace) {
  return string?.split(search)?.join(replace)
}

export const fuelStringSubstitution = (
  fuelContent,
  fuelType,
  location,
  firstLetterUppercase,
  mappedStateWithCities,
  parsedLocationIsState,
  stateCode
) => {
  const fuelPrice = parsedLocationIsState
    ? getStateFuelPrices(location, fuelType, mappedStateWithCities)
    : mappedStateWithCities?.[getStateAndCity(location, mappedStateWithCities, stateCode)]?.[
        getStateAndCity(location, mappedStateWithCities, stateCode, true)
      ][`${fuelType}Price`]
  const defaultUrl =
    location !== ''
      ? `https://www.acko.com/fuel/${fuelType}-price-in-${location.toLowerCase().replace(/\s/g, '-')}`
      : `https://www.acko.com/fuel/${fuelType}-price`

  const replacementsMap = {
    '<fuelType>': firstLetterUppercase ? uppercaseFirstLetter(fuelType) : fuelType?.toLowerCase(),
    '<fuelTypeSmall>': fuelType?.toLowerCase(),
    '&lt;fuelType&gt;': firstLetterUppercase ? uppercaseFirstLetter(fuelType) : fuelType,
    '&lt;fuelTypeSmall&gt;': fuelType?.toLowerCase(),
    '<country>': 'India',
    '<state>': firstLetterUppercase
      ? parsedLocationIsState
        ? capitaliseEveryWord(location)
        : capitaliseEveryWord(getStateAndCity(location, mappedStateWithCities, stateCode))
      : parsedLocationIsState
        ? location
        : getStateAndCity(location, mappedStateWithCities, stateCode).toLowerCase(),
    '&lt;state&gt;': firstLetterUppercase
      ? parsedLocationIsState
        ? capitaliseEveryWord(location)
        : capitaliseEveryWord(getStateAndCity(location, mappedStateWithCities, stateCode))
      : parsedLocationIsState
        ? location
        : getStateAndCity(location, mappedStateWithCities, stateCode).toLowerCase(),
    '<price>': fuelPrice,
    '&lt;price&gt;': fuelPrice,
    '<city>': firstLetterUppercase ? uppercaseFirstLetter(location) : location,
    '&lt;city&gt;': firstLetterUppercase ? uppercaseFirstLetter(location) : location,
    '<location>': firstLetterUppercase ? uppercaseFirstLetter(location) : location,
    '&lt;location&gt;': firstLetterUppercase ? capitaliseEveryWord(location) : location,
    '<date>': getCurrentDate(),
    '&lt;date&gt;': getCurrentDate(),
    '<url>': stateCode ? `${defaultUrl}-${stateCode}` : defaultUrl,
  }

  Object.entries(replacementsMap).forEach(([key, value]) => {
    fuelContent = customReplaceAll(fuelContent, key, value)
  })

  return fuelContent
}
